import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { CartProvider } from "./lib/cart";
import AppRoutes from "./AppRoutes";
import CartDrawer from "./components/CartDrawer";

function App() {
  return (
    <I18nProvider>
      <CartProvider>
        <div className="App grain">
          <BrowserRouter>
            <AppRoutes />
            <CartDrawer />
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                border: "1px solid #27272a",
                color: "#fff",
                borderRadius: "0px",
              },
            }}
          />
        </div>
      </CartProvider>
    </I18nProvider>
  );
}

export default App;
